import type { FC } from "react";

import { categoryIconFilter, i18nCategoryFilter, parentCategoryFilter, subCategoryFilter } from "app/filters/ngFilters";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { trackEvent } from "../SWReactTableTrackEvent";

interface IReferringCategoryCell extends ITableCellProps {
    getLink?: (value: string) => string;
    isIconHidden?: boolean;
    isLinkDisabled?: boolean;
}
export const ReferringCategoryCell: FC<IReferringCategoryCell> = ({
    value,
    tableOptions,
    getLink,
    isIconHidden,
    isLinkDisabled,
}) => {
    let finalLink;
    if (getLink) {
        finalLink = getLink(value);
    } else {
        const params = proNavigator.getParams();
        const curState = proNavigator.current().name;
        finalLink = proNavigator.href(
            // @ts-ignore FIXME: strict migration - 'string | undefined' not assignable to 'StateOrName' — current state name always exists at cell render time
            curState,
            Object.assign(params, {
                referralsCategory: value,
            }),
        );
    }

    return (
        <div className="swTable-categoryCell">
            {!isIconHidden ? (
                <i
                    className={`sprite-category u-right-padding-6 ${categoryIconFilter()(
                        parentCategoryFilter()(value),
                    )}`}
                />
            ) : null}
            {value === "-" || isLinkDisabled ? (
                <span>{subCategoryFilter()(value)}</span>
            ) : (
                <a
                    title={i18nCategoryFilter()(value)}
                    href={finalLink}
                    onClick={() => {
                        trackEvent(tableOptions, "Internal Link", value, "click");
                    }}
                >
                    {subCategoryFilter()(value)}
                </a>
            )}
        </div>
    );
};
ReferringCategoryCell.displayName = "ReferringCategoryCell";
